const categories = {
  entreprises: {
    intro: {
      fr: {
        title: "Services pour les entreprises",
        text:
          "HelvetAssist accompagne les entreprises et indépendants à chaque étape de leur développement en Suisse. Nous proposons un service complet de secrétariat externalisé, de gestion administrative et de support RH. De la création d'entreprise au suivi de la facturation et des assurances sociales, nous optimisons vos processus pour vous faire gagner un temps précieux et sécuriser l'ensemble de vos démarches."
      },
      en: {
        title: "Services for businesses",
        text:
          "HelvetAssist supports companies and self-employed professionals at every stage of their development in Switzerland. We offer comprehensive outsourced secretarial, administrative management, and HR support services. From business incorporation to the handling of invoicing and social security matters, we optimize your processes to save you valuable time and ensure the security of all your operations."
      },
      de: {
        title: "Dienstleistungen für Unternehmen",
        text:
          "HelvetAssist unterstützt Unternehmen und Selbstständige in jeder Phase ihrer Entwicklung in der Schweiz. Wir bieten einen umfassenden Service in den Bereichen externes Sekretariat, administrative Verwaltung und HR-Support. Von der Unternehmensgründung bis hin zur Abwicklung der Rechnungsstellung und der Sozialversicherungen optimieren wir Ihre Prozesse, damit Sie wertvolle Zeit sparen und bei all Ihren Abläufen auf der sicheren Seite sind."
      }
    },

    services: {
      fr: [
        {
          title: "Création et structuration d’entreprise (SA, Sàrl, RI)",
          short: "Accompagnement administratif complet pour créer et structurer votre société en Suisse.",
          full:
            "Nous vous accompagnons dans toutes les démarches administratives liées à la création de votre entreprise (SA, Sàrl, Raison Individuelle). De la préparation des documents pour le notaire à l'inscription au Registre du commerce, en passant par les ouvertures de comptes consignés et les premières affiliations (AVS, TVA), nous veillons à ce que votre structure démarre sur des bases solides et conformes au droit suisse.",
          image: "SARL.jpeg",
          },
        {
          title: "Secrétariat externalisé & assistance administrative",
          short: "Gestion administrative quotidienne flexible, rigoureuse et sur mesure.",
          image: "extarnlise.jpeg",
          full:
            "Nous proposons un service de secrétariat externalisé à distance ou sur site, adapté au rythme de votre activité. Nous prenons en charge la gestion du courrier, le suivi de la boîte e-mail principale, l'organisation des agendas et la tenue à jour de vos dossiers. Nous vous aidons également à structurer vos classements pour fluidifier votre organisation interne."
        },
        {
          title: "Facturation & gestion du débiteur",
          short: "Émission de QR-factures, suivi des paiements et gestion des rappels.",
          image: "facturation.jpeg",
          full:
            "Assurez une trésorerie saine sans perdre de temps. Nous établissons et envoyons vos factures clients avec les normes QR-facture suisses actuelles, suivons les encaissements et gérons le processus de relance et de rappels avec tact et professionnalisme."
        },
        {
          title: "Support RH externalisé & assurances sociales",
          short: "Gestion administrative du personnel conforme au droit du travail suisse.",
          image: "RH.jpeg",
          full:
            " Confiez-nous le suivi administratif de vos collaborateurs. Nous gérons les annonces aux caisses de compensation (AVS, LPP, LAA), le traitement des allocations familiales, le suivi des arrêts maladie/accident et la préparation des éléments pour la gestion des salaires, dans le respect des exigences légales suisses."
        },
        {
          title: "Comptabilité & gestion des fournisseurs",
          short: " Saisie des pièces comptables, préparation des paiements et suivi TVA.",
          image:"compalibite.jpeg",
          full:
            "Ne laissez plus la paperasse comptable s'accumuler. Nous classons, numérisons et préparons l'ensemble de vos factures fournisseurs et justificatifs de dépenses. Nous préparons vos ordres de paiement pour validation et transmettons un dossier propre et structuré à votre fiduciaire pour le bouclage."
        },
        {
          title: "Démarches officielles & correspondances",
          short: "Gestion des relations avec les administrations et obtention d'attestations.",
          image: "demarche.jpeg",
          full:
            "Nous rédigeons vos courriers officiels et gérons les échanges avec les administrations cantonales et fédérales (administration fiscale, office du travail, registre du commerce). Nous nous occupons également d'obtenir vos diverses attestations (extrait du registre des poursuites, attestations AVS/TVA) nécessaires à vos appels d'offres ou démarches bancaires."
        }
      ],

      en: [
        {
          title: "Business Incorporation and Structuring (SA, Sàrl, RI)",
          short: "Comprehensive administrative support for setting up and structuring your company in Switzerland.",
          image: "SARL.jpeg",
          full:
            "We assist you with all administrative procedures involved in setting up your business (SA, Sàrl, or Sole Proprietorship). From preparing documents for the notary and registering with the Commercial Register to opening escrow accounts and handling initial registrations (AHV/AVS, VAT), we ensure your business starts on a solid foundation that complies with Swiss law."
           },
        {
          title: "Outsourced Secretarial & Administrative Support",
          short: "Flexible, meticulous, and tailored day-to-day administrative management.",
          image: "extarnlise.jpeg",
          full:
            "We offer outsourced secretarial services—either remote or on-site—adapted to the pace of your business. We handle mail management, monitor your main email inbox, organize schedules, and keep your files up to date. We also help you structure your filing systems to streamline your internal operations."  },
        {
          title: "Invoicing & Accounts Receivable Management",
          short: "Issuance of QR-invoices, payment tracking, and reminder management.",
          image: "facturation.jpeg",
          full:
            "Ensure great cash flow without wasting time. We prepare and send your client invoices in compliance with current Swiss QR-invoice standards, track incoming payments, and manage the follow-up and reminder process with tact and professionalism."  },
        {
          title: "Outsourced HR support & social insurance",
          short: "Administrative personnel management compliant with Swiss labor law.",
          image: "RH.jpeg",
          full:
            "Entrust us with the administrative management of your employees. We handle notifications to social security funds (AVS, LPP, LAA), the processing of family allowances, the tracking of sick leave and accident-related absences, and the preparation of payroll data, all in compliance with Swiss legal requirements."   },
        {
          title: "Accounting & supplier management",
          short: "Data entry of accounting documents, payment preparation, and VAT tracking.",
          image:"compalibite.jpeg",
          full:
            "Stop letting accounting paperwork pile up. We organize, digitize, and prepare all your supplier invoices and expense receipts. We prepare payment orders for your approval and deliver a clean, structured file to your accounting firm for final closing."      },
        {
          title: "Official Procedures & Correspondence",
          short: "Managing relations with government agencies and obtaining official certificates.",
          image: "demarche.jpeg",
          full:
            "We draft your official correspondence and handle communications with cantonal and federal authorities (tax authorities, employment offices, the commercial register). We also take care of obtaining the various certificates (debt enforcement register extracts, AVS/VAT confirmations) required for your tenders or banking procedures."   }
      ],

      de: [
        {
          title: "Gründung und Strukturierung von Unternehmen (AG, GmbH, Einzelunternehmen)",

short: "Umfassende administrative Begleitung für die Gründung und Strukturierung Ihres Unternehmens in der Schweiz.",

full:
  "Wir begleiten Sie bei allen administrativen Schritten im Zusammenhang mit der Gründung Ihres Unternehmens (AG, GmbH, Einzelunternehmen). Von der Vorbereitung der Unterlagen für den Notar über die Eintragung ins Handelsregister bis hin zur Eröffnung von Kapitaleinzahlungskonten und den ersten Anmeldungen (AHV, MWST) stellen wir sicher, dass Ihre Struktur auf soliden und rechtskonformen Grundlagen startet.",

image: "SARL.jpeg",    },
        {
          title: "Externes Sekretariat & administrative Unterstützung",

short: "Flexible, strukturierte und maßgeschneiderte tägliche Administration.",

image: "extarnlise.jpeg",

full:
  "Wir bieten einen externen Sekretariatsservice – remote oder vor Ort – angepasst an den Rhythmus Ihrer Tätigkeit. Wir übernehmen die Verwaltung Ihrer Post, die Betreuung Ihres Haupt-E-Mail-Postfachs, die Organisation von Terminen sowie die Pflege Ihrer Unterlagen. Zudem unterstützen wir Sie bei der Strukturierung Ihrer Ablagen, um Ihre internen Prozesse effizienter zu gestalten."
 },
        {
          title: "Rechnungsstellung & Debitorenmanagement",

short: "Erstellung von QR-Rechnungen, Zahlungsüberwachung und Mahnwesen.",

image: "facturation.jpeg",

full:
  "Sichern Sie Ihre Liquidität, ohne Zeit zu verlieren. Wir erstellen und versenden Ihre Kundenrechnungen nach den aktuellen Schweizer QR-Rechnungsstandards, überwachen Zahlungseingänge und übernehmen das Mahnwesen mit Takt und Professionalität."
  },
        {
         title: "Externes HR & Sozialversicherungen",

short: "Administrative Personalverwaltung im Einklang mit dem Schweizer Arbeitsrecht.",

image: "RH.jpeg",

full:
  "Überlassen Sie uns die administrative Betreuung Ihrer Mitarbeitenden. Wir kümmern uns um Meldungen an Ausgleichskassen (AHV, BVG, UVG), die Abwicklung von Familienzulagen, die Nachverfolgung von Krankheits- und Unfallmeldungen sowie die Vorbereitung der Unterlagen für die Lohnverarbeitung – stets unter Einhaltung der gesetzlichen Anforderungen in der Schweiz."
        },
        {
          title: "Vorbuchhaltung & Lieferantenmanagement",

short: "Erfassung von Belegen, Vorbereitung von Zahlungen und MWST-Überwachung.",

image:"compalibite.jpeg",

full:
  "Lassen Sie keine Buchhaltungsunterlagen mehr liegen. Wir sortieren, digitalisieren und bereiten sämtliche Lieferantenrechnungen und Spesenbelege auf. Wir erstellen Zahlungsaufträge zur Freigabe und übergeben Ihrer Treuhandgesellschaft ein sauberes und strukturiertes Dossier für den Abschluss."

    },
        {
        title: "Offizielle Verfahren & Korrespondenz",

short: "Verwaltung von Beziehungen zu Behörden und Beschaffung von Bescheinigungen.",

image: "demarche.jpeg",

full:
  "Wir verfassen Ihre offiziellen Schreiben und übernehmen die Kommunikation mit kantonalen und eidgenössischen Behörden (Steuerverwaltung, Arbeitsamt, Handelsregister). Zudem kümmern wir uns um die Beschaffung verschiedener Bescheinigungen (Betreibungsregisterauszug, AHV-/MWST-Bestätigungen), die Sie für Ausschreibungen oder Bankgeschäfte benötigen."
   }
      ]
    }
  },

  prive: {
    intro: {
      fr: {
        title: "Services pour les particuliers",
        text:
          "HelvetAssist offre un accompagnement administratif personnalisé aux particuliers et aux familles en Suisse. Qu'il s'agisse de trier votre courrier, de payer vos factures, de préparer votre déclaration d'impôts dès CHF 50.- ou de vous aider dans vos démarches de logement et d'assurances, nous prenons en charge toute votre paperasse avec rigueur et confidentialité."
      },
      en: {
        title: "Services for individuals",
        text:
          "HelvetAssist offers personalized administrative support to individuals and families in Switzerland. Whether it involves sorting your mail, paying bills, preparing your tax return (starting at CHF 50), or assisting with housing and insurance matters, we handle all your paperwork with precision and confidentiality."
      },
      de: {
        title: "Dienstleistungen für Privatpersonen",
        text:
          "HelvetAssist bietet Privatpersonen und Familien in der Schweiz eine individuelle administrative Unterstützung. Ob es um das Sortieren Ihrer Post, das Bezahlen von Rechnungen, die Erstellung Ihrer Steuererklärung (ab CHF 50.–) oder um Hilfe bei Wohnungs- und Versicherungsangelegenheiten geht – wir erledigen Ihren gesamten Schriftverkehr gewissenhaft und vertraulich."
      }
    },

    services: {
      fr: [
        {
          title: "Assistance administrative sur mesure, budget & secrétariat",
          short: "Prise en charge de votre courrier, formulaires, factures et suivi de vos dossiers.",
          image: "paying.png",
          full:
            "Un service complet et flexible pour répondre à tout besoin administratif du quotidien. Nous assurons le tri, le classement et la numérisation de votre courrier, la rédaction de vos correspondances officielles ainsi que le remplissage de tout type de formulaire complexe. Nous gérons également le traitement de vos QR-factures, vos échéanciers et la tenue de votre budget ménager pour assurer un suivi rigoureux et sans stress de tous vos dossiers."
        },
        {
          title: "Création et structuration d'entreprise (SA, Sàrl, RI)",
          short: "Accompagnement complet pour lancer votre activité en Suisse.",
             image: "SARLprive.jpeg",
          full:
            "Nous accompagnons les entrepreneurs à chaque étape de la création de leur entreprise en Suisse, que ce soit sous la forme d'une SA, d'une Sàrl ou d'une raison individuelle (RI). De l'analyse de votre projet au choix de la structure juridique la plus adaptée, nous vous apportons un conseil personnalisé, en tenant compte de vos objectifs, de votre situation et des exigences légales. Nous prenons en charge l'ensemble des démarches administratives et veillons à une structuration claire et conforme, afin de vous permettre de démarrer votre activité sur des bases solides et sereines. La création d'une SA ou d'une Sàrl est possible avec nous, même sans capital initial, grâce à des solutions adaptées que nous mettons en place dans le respect du cadre légal suisse."
        },
        {
          title: "Assurances, subsides & aides financières",
          image: "assurance.jpeg",
          short: "Optimisation de vos polices d'assurance, demandes de subsides et aides cantonales.",
          full:
            "Ne passez plus à côté des aides auxquelles vous avez droit. Nous analysons vos contrats d'assurance (LAMal, complémentaires, RC/Ménage) et vérifions vos décomptes médicaux. Nous préparons et soumettons l'ensemble de vos demandes de subsides assurance-maladie, allocations familiales et autres formulaires de demandes d'aides financières ou sociales auprès des organismes cantonaux et communaux."
        },
        {
          title: "Logement, recherche, déménagement & remise de clés",
          short: "Recherche du logement idéal, dossiers de régie, nettoyage et débarras.",
            image: "logment.jpeg",
          full:
            "Nous vous accompagnons de A à Z dans votre projet de logement. Nous vous aidons à chercher et trouver votre logement idéal, constituons des dossiers de candidature solides pour les régies et gérons vos formalités de changement d'adresse. Pour votre déménagement, nous organisons et coordonnons également la prise en charge du nettoyage de fin de bail avec garantie de restitution ainsi que le débarras de vos encombrants."
           },
        {
          title: "Installation en Suisse & permis de séjour",
          short: "Formalités d'arrivée, permis (B, C, L, G) et enregistrements officiels.",
           image:"passport.jpeg",
          full:
            "Un accompagnement clé en main pour réussir votre installation en Suisse. Nous gérons la constitution de vos dossiers pour l'obtention ou le renouvellement de vos permis de séjour (B, C, L, G), l'affiliation aux assurances obligatoires et toutes vos démarches auprès du contrôle de l'habitant et des services cantonaux de la population."
           },
        {
          title: "Déclaration d'impôts — dès CHF 50.-",
          short: "Remplissage rapide et conforme, sans vous déplacer et en quelques clics.",
          image: "impots.jpeg",
          full:
            "Confiez-nous votre déclaration d'impôts à un tarif imbattable dès CHF 50.- ! Sans besoin de vous déplacer, transmettez-nous simplement vos documents de manière sécurisée en quelques clics. Nous rassemblons vos pièces, optimisons vos déductions légales (frais professionnels, 3e pilier, assurances, frais médicaux) et établissons votre déclaration dans le respect des exigences fiscales de votre canton."
           }
      ],

      en: [
        {
         title: "Tailored administrative support, budgeting & secretarial services",
    short: "Handling your mail, forms, invoices and monitoring your files.",
    image: "paying.png",
    full:
      "A complete and flexible service to meet all your daily administrative needs. We handle the sorting, filing and digitization of your mail, draft your official correspondence, and complete all types of complex forms. We also manage your QR invoices, payment schedules, and household budget to ensure a structured and stress-free follow-up of all your matters."
  },
        {
           title: "Company creation and structuring (SA, Sàrl, RI)",
    short: "Comprehensive support to launch your business in Switzerland.",
    image: "SARLprive.jpeg",
    full:
      "We support entrepreneurs at every stage of setting up their business in Switzerland, whether as a public limited company (SA), a limited liability company (LLC), or a sole proprietorship. From analyzing your project to choosing the most suitable legal structure, we provide personalized advice based on your goals, situation, and legal requirements. We handle all administrative procedures and ensure a clear and compliant structure so you can start your business on solid and secure foundations. Creating an SA or LLC is possible with us, even without initial capital, thanks to tailored solutions implemented in compliance with Swiss law."
     },
        {
          title: "Insurance, subsidies & financial aid",
    image: "assurance.jpeg",
    short: "Optimization of your insurance policies, subsidy applications and cantonal aid.",
    full:
      "Don’t miss out on benefits you are entitled to. We analyze your insurance contracts (basic health insurance, supplementary plans, liability/household) and review your medical statements. We prepare and submit all your applications for health insurance subsidies, family allowances, and other financial or social aid forms to cantonal and municipal authorities."
    },
        {
          title: "Housing, search, relocation & key handover",
    short: "Finding the ideal home, rental applications, cleaning and clearance.",
    image: "logment.jpeg",
    full:
      "We support you from A to Z in your housing project. We help you search for and find your ideal home, prepare strong rental application files for agencies, and manage your address change procedures. For your move, we also organize and coordinate end-of-lease cleaning with handover guarantee, as well as the disposal of bulky items."
  },
        {
            title: "Relocation to Switzerland & residence permits",
    short: "Arrival formalities, permits (B, C, L, G) and official registrations.",
    image: "passport.jpeg",
    full:
      "A turnkey service to ensure a smooth relocation to Switzerland. We prepare your applications for obtaining or renewing residence permits (B, C, L, G), manage mandatory insurance registrations, and handle all procedures with the residents’ registration office and cantonal population services."
  },
        {
        title: "Tax declaration — from CHF 50.-",
    short: "Fast and compliant filing, without leaving your home and in just a few clicks.",
    image: "impots.jpeg",
    full:
      "Entrust us with your tax return at an unbeatable price starting from CHF 50.-. No need to travel—simply send us your documents securely in just a few clicks. We gather your documents, optimize your legal deductions (professional expenses, pillar 3a, insurance, medical costs), and prepare your tax return in compliance with your canton’s tax requirements."
     }
      ],

      de: [
        {
         title: "Maßgeschneiderte administrative Unterstützung, Budgetierung & Sekretariat",
    short: "Bearbeitung Ihrer Post, Formulare, Rechnungen und Nachverfolgung Ihrer Unterlagen.",
    image: "paying.png",
    full:
      "Ein umfassender und flexibler Service für alle administrativen Bedürfnisse im Alltag. Wir übernehmen das Sortieren, Ablegen und Digitalisieren Ihrer Post, das Verfassen Ihrer offiziellen Korrespondenz sowie das Ausfüllen aller Arten von komplexen Formularen. Außerdem kümmern wir uns um die Verarbeitung Ihrer QR-Rechnungen, Ihre Zahlungspläne und die Führung Ihres Haushaltsbudgets, um eine strukturierte und stressfreie Verwaltung all Ihrer Angelegenheiten zu gewährleisten."
     },
        {
           title: "Gründung und Strukturierung von Unternehmen (SA, Sàrl, RI)",
    short: "Umfassende Unterstützung beim Start Ihrer Tätigkeit in der Schweiz.",
    image: "SARLprive.jpeg",
    full:
      "Wir begleiten Unternehmer in jeder Phase der Unternehmensgründung in der Schweiz, sei es als Aktiengesellschaft (AG), Gesellschaft mit beschränkter Haftung (GmbH) oder Einzelunternehmen. Von der Analyse Ihres Projekts bis zur Wahl der am besten geeigneten Rechtsform bieten wir Ihnen eine individuelle Beratung unter Berücksichtigung Ihrer Ziele, Ihrer Situation und der gesetzlichen Anforderungen. Wir übernehmen sämtliche administrativen Schritte und sorgen für eine klare und rechtskonforme Struktur, damit Sie Ihre Tätigkeit auf soliden und sicheren Grundlagen starten können. Die Gründung einer AG oder GmbH ist mit uns auch ohne Anfangskapital möglich, dank maßgeschneiderter Lösungen im Rahmen des Schweizer Rechts."
     },
        {
        title: "Versicherungen, Subventionen & finanzielle Unterstützung",
    image: "assurance.jpeg",
    short: "Optimierung Ihrer Versicherungen, Anträge für Subventionen und kantonale Unterstützung.",
    full:
      "Verpassen Sie keine Leistungen, auf die Sie Anspruch haben. Wir analysieren Ihre Versicherungsverträge (Grundversicherung, Zusatzversicherungen, Haftpflicht/Haushalt) und prüfen Ihre medizinischen Abrechnungen. Wir bereiten alle Ihre Anträge für Krankenkassen-Prämienverbilligungen, Familienzulagen sowie weitere finanzielle oder soziale Unterstützungen vor und reichen diese bei kantonalen und kommunalen Behörden ein."
    },
        {
           title: "Wohnen, Suche, Umzug & Schlüsselübergabe",
    short: "Suche nach der idealen Wohnung, Bewerbungsdossiers, Reinigung und Räumung.",
    image: "logment.jpeg",
    full:
      "Wir begleiten Sie von A bis Z bei Ihrem Wohnprojekt. Wir helfen Ihnen bei der Suche nach Ihrer idealen Wohnung, erstellen überzeugende Bewerbungsdossiers für Verwaltungen und kümmern uns um Ihre Adressänderungen. Für Ihren Umzug organisieren und koordinieren wir auch die Endreinigung mit Abgabegarantie sowie die Entsorgung von Sperrgut."
   },
        {
         title: "Umzug in die Schweiz & Aufenthaltsbewilligungen",
    short: "Anmeldeformalitäten, Bewilligungen (B, C, L, G) und offizielle Registrierungen.",
    image: "passport.jpeg",
    full:
      "Ein Rundum-Service für einen erfolgreichen Start in der Schweiz. Wir erstellen Ihre Unterlagen für die Beantragung oder Verlängerung Ihrer Aufenthaltsbewilligungen (B, C, L, G), kümmern uns um die Anmeldung bei den obligatorischen Versicherungen und übernehmen alle Formalitäten beim Einwohneramt sowie bei den kantonalen Behörden."
  },
        {
             title: "Steuererklärung — ab CHF 50.-",
    short: "Schnelle und konforme Erstellung, ohne Aufwand und in wenigen Klicks.",
    image: "impots.jpeg",
    full:
      "Überlassen Sie uns Ihre Steuererklärung zu einem unschlagbaren Preis ab CHF 50.-. Ohne dass Sie sich bewegen müssen, senden Sie uns einfach Ihre Unterlagen sicher in wenigen Klicks. Wir sammeln Ihre Dokumente, optimieren Ihre gesetzlichen Abzüge (Berufskosten, Säule 3a, Versicherungen, medizinische Kosten) und erstellen Ihre Steuererklärung gemäß den steuerlichen Anforderungen Ihres Kantons."
    }
      ]
    }
  }
};

export default categories;
